import { formatNumber, ParsedNumber, parseNumber } from "libphonenumber-js";
import React from "react";
type PhoneProps = {
  number: string;
  ext?: React.ReactNode;
  missing?: React.ReactNode;
};

const PhoneNumber: React.FC<PhoneProps> = (props: PhoneProps) => {
  if (props.missing) {
    return <span style={{ fontStyle: "italic" }}>{props.missing}</span>;
  }

  if (!props.number) return null;

  const parsed = parseNumber(props.number, "US") as ParsedNumber;
  const display = formatNumber(parsed, "NATIONAL");
  const formatted = formatNumber(parsed, "RFC3966");
  const tel = props.ext ? `${formatted},${props.ext}` : `${formatted}`;

  return (
    <>
      <a href={tel}>{display}</a> {props.ext && <small>ext. {props.ext}</small>}
    </>
  );
};

export default PhoneNumber;
